var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"transaction-list",attrs:{"for-render":_vm.renderElement}},[_c('h4',{staticClass:"title"},[_vm._v("订单记录")]),_c('table',{staticClass:"compact hover",staticStyle:{"width":"100%"},attrs:{"id":"transaction-table"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }